import {
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { BadgePurple } from "../../../../../components/badge/Badge";
import { Card } from "@sellar-io/components";
import { OrderDiscountSummary } from "../../../../../components/discountSummary/OrderDiscountSummary";
import { AlertContainer } from "../../../../../components/alert/AlertContainer";
import { formatCurrency } from "@sellar-io/common";

export const StorefrontDiscountCard = ({
  orderDiscountAmount,
  orderCurrency,
  className,
  priceTierDiscounts,
  caseSizeRuleList,
}: {
  orderDiscountAmount: number;
  orderCurrency: SupplierGetResponseType["currency"];
  className?: string;
  priceTierDiscounts: NonNullable<
    SupplierStorefrontV2GetResponseType["VolumeDiscounts"]
  >["PriceTierDiscounts"];
  caseSizeRuleList: SupplierStorefrontV2GetResponseType["CaseSizeRules"]["list"];
}): ReactElement | null => {
  if (!priceTierDiscounts.length) return null;
  return (
    <Card className={twMerge("bg-white", "flex flex-col gap-2 p-4", className)}>
      <BadgePurple icon={"TAG_MULTIPLE_OUTLINE"}>Volume discounts</BadgePurple>
      {!!orderDiscountAmount && (
        <AlertContainer className={"mt-1 w-full p-4"} type={"discount"}>
          You're saving{" "}
          <strong>{formatCurrency(orderDiscountAmount, orderCurrency)} </strong>{" "}
          on this order
        </AlertContainer>
      )}
      <OrderDiscountSummary
        discounts={priceTierDiscounts}
        currency={orderCurrency}
        hideInfo={true}
        caseSizeRuleList={caseSizeRuleList}
      />
    </Card>
  );
};

export const DiscountCard = () => {};
